import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IconCheckmarkFill, IconCloseFill } from '@saucelabs/ds-icons';
import { Loader } from '@saucelabs/sl-component-loader';

import Styles from './BiometricAuthenticationPopover.styles';
import operations from '../operations';
import selectors from '../selectors';
import { MANUAL_TEST_EVENTS, trackEvent } from './../../../tracking';

const { biometricAuthenticationPopoverSelector } = selectors;

const BUTTON_BASE_CLASSES = `${Styles.button}
  bg-white fill-current cursor-pointer
  hover:bg-blue-50 focus:bg-blue-50 active:bg-blue-100
  disabled:bg-transparent disabled:cursor-not-allowed disabled:text-gray-disabled
`;

const BiometricAuthenticationPopover = ({
  isLoading,
  performBiometricAuthentication,
}) => {
  useEffect(() => {
    trackEvent(MANUAL_TEST_EVENTS.SHOW_BIOMETRIC_AUTHENTICATION_POPOVER);
  }, []);

  const onClickHandlerPass = () => performBiometricAuthentication({ match: true });
  const onClickHandlerFail = () => performBiometricAuthentication({ match: false });

  return (
    <div
      className={Styles.default}
      data-qa="biometrics-authentication-popover"
    >
      <div className={Styles.headline}>Biometric Authentication</div>
      <div className={Styles.info}>
        Choose a response for fingerprint or face recognition.
      </div>
      <div className={Styles['buttons-wrapper']}>
        <button
          className={`${BUTTON_BASE_CLASSES} text-green-400`}
          data-qa="biometric-authentication-popover-pass"
          disabled={isLoading}
          onClick={onClickHandlerPass}
          type="button"
        >
          <IconCheckmarkFill />
          <span className={`${Styles['button-label']} ${isLoading ? 'text-gray-disabled' : 'text-gray-600'}`}>Pass</span>
        </button>
        <button
          className={`${BUTTON_BASE_CLASSES} text-red-600`}
          data-qa="biometric-authentication-popover-fail"
          disabled={isLoading}
          onClick={onClickHandlerFail}
          type="button"
        >
          <IconCloseFill />
          <span className={`${Styles['button-label']} ${isLoading ? 'text-gray-disabled' : 'text-gray-600'}`}>Fail</span>
        </button>
      </div>
      <Loader
        className={Styles.loader}
        fontSize="1.1rem"
        show={isLoading}
      />
    </div>
  );
};

BiometricAuthenticationPopover.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  performBiometricAuthentication: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  performBiometricAuthentication: operations.performBiometricAuthentication,
};

export default connect(
  biometricAuthenticationPopoverSelector,
  mapDispatchToProps,
)(BiometricAuthenticationPopover);

export {
  BiometricAuthenticationPopover,
};
